import { faFile, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type ImageFileProps = {
    src: string;
    contentType: string;
    alt: string;
    className?: string;
}

const ImageFile = (props: ImageFileProps) => {
    if (props.contentType.startsWith('image/')) {
        return <img src={props.src} alt={props.alt} className={props.className} />;
    }

    if (props.src.endsWith('.pdf') || props.contentType === 'application/pdf') {
        return <FontAwesomeIcon icon={faFilePdf} className={props.className} />;
    }

    return <FontAwesomeIcon icon={faFile} className={props.className} />;
}

export default ImageFile;